export const STUDY_INSIGHTS_TRANSLATION = 'study-insights';

export const COLLECTION_LOCATION = {
  HOME: 'AT_HOME',
  PERSON: 'IN_PERSON',
};

export const GOAL_ID = {
  BASELINE: 'baseline',
  LIFETIME: 'lifetime',
  YEARLY: 'yearly',
};

export const CAMPAIGN_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};
